export default __webpack_public_path__ + "static/media/card3.cc4792a7.png";